import React from 'react';

import type { ComboboxSearchProps } from '@mantine/core';
import { Combobox as MantineCombobox, useCombobox } from '@mantine/core';

import { ComboboxResolver } from '@/new_src/view/components/Combobox/resolver';
import {
  injectDefaultDropdownSelectorStyles,
  injectDefaultOptionStyles,
} from '@/new_src/view/components/Combobox/styles';

import { Icon } from 'components/atoms/Icon';
import SearchIcon from 'images/icons/search-icon.png';

import { defaultTheme } from '@/theme';

const StyledDropdown = injectDefaultDropdownSelectorStyles(MantineCombobox.Dropdown);
const StyledOption = injectDefaultOptionStyles(MantineCombobox.Option);

const SearchWithIcon = (props: ComboboxSearchProps) => {
  return (
    <MantineCombobox.Search
      rightSection={
        props.rightSection ?? (
          <Icon width={13} height={13} url={SearchIcon} color={defaultTheme.mantineColors.gray[8]} />
        )
      }
      {...props}
    />
  );
};

/** @HeadlessComponent */
const Combobox = Object.assign(MantineCombobox, {
  Dropdown: StyledDropdown,
  Option: StyledOption,
  SearchWithIcon,
});

export { Combobox, ComboboxResolver, useCombobox };
